import { ReduxAction } from '../../actions';
import { SubscribeModalsState } from './state';

const INITIAL_STATE: SubscribeModalsState = {
  educator: {
    show: false,
    canDismiss: false,
    mode: 'subscribe',
  },
  personal: {
    show: false,
    canDismiss: false,
    mode: 'trial',
  },
  courseAccessDenied: {
    show: false,
    subscriptionId: null,
  },
};

export const SubscribeModals = (
  state: SubscribeModalsState = INITIAL_STATE,
  action: ReduxAction
): SubscribeModalsState => {
  switch (action.type) {
    case 'SUBSCRIBE_MODALS_SHOW_PRICING_MODAL': {
      const { planType, canDismiss, mode } = action;
      return {
        ...state,
        [planType]: {
          show: true,
          canDismiss,
          mode,
        },
      };
    }
    case 'SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL': {
      const { planType } = action;
      if (state[planType].canDismiss) {
        return {
          ...state,
          [planType]: {
            show: false,
          },
        };
      }
      return state;
    }
    case 'SUBSCRIPTION_PAYMENT_START': {
      const { planType } = action;
      if (planType === 'educator' || planType === 'personal') {
        const modalState = state[planType];
        return {
          ...state,
          [planType]: {
            ...modalState,
            canDismiss: false,
          },
        };
      }
      return state;
    }
    case 'COURSE_ACCESS_DENIED': {
      const { subscriptionId, isLegacyEducator } = action;
      if (isLegacyEducator) {
        return {
          ...state,
          educator: {
            show: true,
            canDismiss: false,
            mode: 'subscribe',
          },
        };
      } else {
        return {
          ...state,
          courseAccessDenied: {
            show: true,
            subscriptionId,
          },
        };
      }
    }
    default:
      return state;
  }
};
